module.exports = __webpack_public_path__ + "static/media/hormel.706728e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hormel.png
// module id = 69
// module chunks = 0